import { createApp } from 'vue'
import Main from './Main.vue'
import router from './router'
import DropdownDirective from '@ui/directives/dropdown-toggle'
import formValidation from '@ui/form-validation/form-validation'
import './assets/css/site.css'

createApp(Main)
    .use(router)
    .directive('form', formValidation)
    .directive('dropdown-toggle', DropdownDirective)
    .mount('#app')
